module.exports = "/_next/static/images/Hero@2x-4e6db9b31d167785da4cc0c9c6d90c70.webp";